import React from "react";
import { RepoItem } from "../../../autogenerated/ZoomBridge";
import { DATA_CM } from "../util/util_CM";
type PopoverProps = {
    asset: RepoItem,
    fetchAssets: Function,
    modal: string,
    onClose: Function,
}

type Info = {
    ADDITIONAL_PROPS: Array<object>,
    COMPONENT: React.Component,
    MODAL: String,
    PROPS: Array<string>,
}

function Popover_CM(props: PopoverProps) {
    const { modal } = props;
    const info: Info = DATA_CM.PORTALS[modal];
    const PopupComponent = info.COMPONENT;
    const args = DATA_CM.FUNCTIONS.fileterProps(props, info.PROPS, info.ADDITIONAL_PROPS)
    return <PopupComponent {...args}/>
}

export default Popover_CM;